/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum DateOptions {
  ALL_TIME = "ALL_TIME",
  MONTH_TO_DATE = "MONTH_TO_DATE",
  WEEK_TO_DATE = "WEEK_TO_DATE",
  YEAR_TO_DATE = "YEAR_TO_DATE",
}

export enum GroupRoleType {
  Admin = "Admin",
  Member = "Member",
}

export enum SubjectRoleType {
  ADMIN = "ADMIN",
  MEMBER = "MEMBER",
}

export enum TrackerType {
  BINARY = "BINARY",
  FIVER = "FIVER",
  INTEGER = "INTEGER",
  TRAFFIC_LIGHT = "TRAFFIC_LIGHT",
}

export interface AcceptAccountMembershipInput {
  inviteCode: string;
  password?: string | null;
}

export interface AccountInvitationsInput {
  accountId: string;
  onlyPending?: boolean | null;
}

export interface AccountMembersInput {
  accountId: string;
}

export interface AddMemberToSubjectInput {
  subjectId: string;
  memberId: string;
}

export interface ChangeGroupMembershipPermissionsInput {
  groupMemberId: string;
  roleType: GroupRoleType;
}

export interface ChangeMembershipPermissionsInput {
  memberId: string;
  roleType: string;
}

export interface ChangePasswordInput {
  userId: string;
  password?: string | null;
}

export interface ChangeSubjectMembershipPermissionsInput {
  subjectMembershipId: string;
  roleType: SubjectRoleType;
}

export interface CreateAccountInput {
  name: string;
  ownerId: string;
  displayName: string;
  type?: string | null;
  template?: string | null;
}

/**
 * The creator of an invite must be a Quala Admin
 */
export interface CreateInvitationInput {
  email: string;
  name?: string | null;
  organization?: string | null;
}

export interface CreateNotebookInput {
  name: string;
  accountId: string;
  templateId?: string | null;
}

export interface CreateOrUpdateGroupInput {
  notebookId: string;
  id?: string | null;
  name?: string | null;
  description?: string | null;
  subjectIds?: (string | null)[] | null;
  trackerIds?: (string | null)[] | null;
  parentGroupId?: string | null;
}

export interface CreateOrUpdateNoteInput {
  notebookId: string;
  noteId?: string | null;
  subjectIds?: (string | null)[] | null;
  authorId?: string | null;
  content?: string | null;
  context?: string | null;
  measurements?: NoteMeasurementInput[] | null;
  notedAt?: any | null;
}

export interface CreateOrUpdateSubjectInput {
  notebookId: string;
  id?: string | null;
  name?: string | null;
  description?: string | null;
  trackerIds?: (string | null)[] | null;
  groupIds?: (string | null)[] | null;
}

export interface CreateOrUpdateTrackerInput {
  id?: string | null;
  notebookId: string;
  name?: string | null;
  purpose?: string | null;
  type?: TrackerType | null;
  subjectId?: string | null;
  groupId?: string | null;
  active?: boolean | null;
}

export interface DateFilter {
  preset?: DateOptions | null;
  weekOffset?: number | null;
  monthOffset?: number | null;
  yearOffset?: number | null;
  beginDate?: any | null;
  endDate?: any | null;
}

export interface DeleteNoteInput {
  id: string;
}

export interface EditAccountInput {
  id: string;
  name: string;
}

export interface EditAccountMembershipInput {
  memberId: string;
  displayName?: string | null;
  email?: string | null;
  reportsToId?: string | null;
}

export interface EditNotebookInput {
  notebookId: string;
  name?: string | null;
}

export interface EditUserInput {
  userId: string;
  displayName?: string | null;
  email?: string | null;
}

export interface GroupMembersInput {
  groupId: string;
}

export interface InviteMemberToGroupInput {
  groupId: string;
  memberId: string;
}

export interface InviteMemberToNotebookInput {
  notebookId: string;
  memberId: string;
}

export interface InviteUserInput {
  accountId: string;
  email: string;
  displayName: string;
}

export interface MeasurementsQueryInput {
  notebookId: string;
  dateFilter?: DateFilter | null;
  subjectIds?: (string | null)[] | null;
  trackerIds?: (string | null)[] | null;
}

export interface NoteMeasurementInput {
  subjectId: string;
  trackerId: string;
  value: number;
}

export interface NotebookMembersInput {
  notebookId: string;
}

export interface NotebooksQueryInput {
  isArchived?: boolean | null;
  accountId: string;
}

export interface NotesQueryInput {
  notebookId: string;
  dateFilter?: DateFilter | null;
  subjectIds?: (string | null)[] | null;
  trackerIds?: (string | null)[] | null;
  groupIds?: (string | null)[] | null;
  before?: string | null;
  after?: string | null;
  first?: number | null;
  last?: number | null;
}

export interface RegisterInput {
  email?: string | null;
  password: string;
  inviteCode: string;
  includeDemoNotebooks?: boolean | null;
  template?: string | null;
}

export interface RemoveMemberFromGroupInput {
  groupId: string;
  memberId: string;
}

export interface RemoveMemberFromNotebookInput {
  notebookId: string;
  notebookMemberId: string;
}

export interface RemoveMemberFromSubjectInput {
  subjectId: string;
  memberId: string;
}

export interface SetAvatarInput {
  userId: string;
  avatarUrl?: string | null;
}

export interface SubjectMembersInput {
  subjectId: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
